import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=2d0800f6"
import script from "./VPagination.vue?vue&type=script&lang=js"
export * from "./VPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports